import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const SiteContext = createContext({ site: null, categories: [] });

export function SiteProvider({ children }) {
  const [site, setSite] = useState(null);
  const [categories, setCategories] = useState([]);
  useEffect(() => {
    api.get("/public/site").then((r) => setSite(r.data)).catch(() => setSite({}));
    api.get("/categories").then((r) => setCategories(r.data)).catch(() => {});
  }, []);
  return <SiteContext.Provider value={{ site, categories }}>{children}</SiteContext.Provider>;
}

export const useSite = () => useContext(SiteContext);
